import React from 'react';
import PriceAndFinanceMap from './PriceAndFinance';
import SelectProductsProvider from '../SelectProductsContext/SelectProductsProvider';

const PriceAndFinance = props => (
  <SelectProductsProvider>
    <PriceAndFinanceMap {...props} />
  </SelectProductsProvider>
);

export default PriceAndFinance;
